<template>
	<ui-modal-template>
		<template v-slot:title>
			Gratis-Abo erstellen
		</template>
		<template v-slot:content>
			<form class="h-full flex flex-col">
				<div class="px-0 py-6">
					<div class="flex px-6">
						<ui-input-group
							class="basis-full md:basis-1/3 px-6 py-4"
							v-model="form.user_id"
							field="user_id"
							label="User-ID"
							:form="form"
							:required="true"
							suffix="ID"
							tooltipText="ID des Users"
						></ui-input-group>
					</div>

					<div class="flex px-6">
						<ui-input-group
							class="basis-full md:basis-1/3 px-6 py-4"
							v-model="form.valid_from"
							field="valid_from"
							label="Startdatum"
							:form="form"
							:required="true"
							suffix="Tag"
							tooltipText="Format: DD-MM-YYYY"
						></ui-input-group>

						<ui-input-group
							class="basis-full md:basis-1/3 px-6 py-4"
							v-model="form.valid_until"
							field="valid_until"
							label="Ablaufdatum"
							:form="form"
							:required="true"
							suffix="Tag"
							tooltipText="Format: DD-MM-YYYY"
						></ui-input-group>
					</div>
				</div>

				<div class="bg-gray-100 p-6">
					<div class="flex justify-end px-6">
						<ui-button
							:disabled="form.processing"
							v-on:click="submitForm()"
							label="Save"
						/>
					</div>
				</div>
			</form>
		</template>
		<!-- devide -->
	</ui-modal-template>
</template>
<script>
import axios from "axios";
import Vue from "vue";
export default {
	data() {
		const today = new Date();
		const date = new Intl.DateTimeFormat('de-DE', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric'
		}).format(today);

		const formData = {
			user_id: null,
			valid_from: date,
			valid_until: null,
		};

		return {
			form: Vue.observable(this.$inertia.form(formData)),
		};
	},
	computed: {
	},
	methods: {
		async submitForm() {
			let promise = new Promise((resolve, reject) => {
				const response = axios.post(
					this.$route("admin.subscriptions.create"),
					this.form
				);

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			this.$bus.$emit("modal:close");
			// this.$bus.$emit("page:content:load");
			window.location.reload();
		},
		onError(error) {

			switch (error.response.status) {
				case 422:
					const errors = error.response.data.errors;
					this.$bus.$emit("form:invalid", errors);
					break;

				default:
					this.$bus.$emit("modal:error", error);
					break;
			}

		}
	},
};
</script>
